const fonts = {
    body: 'Work-Sans, Helvetica Neue, Helvetica, sans-serif',
    heading: 'Oswald, Helvetica Neue, Helvetica, sans-serif',
    oswald: 'Oswald, Helvetica Neue, Helvetica, sans-serif',
    workSans: 'Work-Sans, Helvetica Neue, Helvetica, sans-serif',
}

export default fonts
